module.exports = __webpack_public_path__ + "../front/img/full-wardrobe-thumb.c0ee9666.jpg";